import Button from '@mui/material/Button';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { CONTEXT, GA_PAGE } from '../constants';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { filterTypes } from './filterTypes';
import makeStyles from '@mui/styles/makeStyles';
import { BasicFiltersWrapper } from '../../../components/BasicFiltersWrapper';
import BasicFilters from '../../../components/Filters/basicFilters';

const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.palette.altButton,
    width: 'fit-content',
    minWidth: 'none',
  },
}));

export default ({ filters, setFilters, clearFilters }) => {
  const classes = useStyles();

  return (
    <ErrorBoundary>
      <Grid
        container
        size={10}
        sx={{
          justifyContent: 'space-evenly',
        }}
      >
        <BasicFiltersWrapper numberOfFields={filterTypes?.length}>
          <BasicFilters
            filters={filters}
            applyFilters={setFilters}
            basicFilterTypes={filterTypes}
            context={CONTEXT}
            googleAnalyticsTag={GA_PAGE}
          />
        </BasicFiltersWrapper>
      </Grid>
      <Grid
        direction="row"
        size={2}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button className={classes.button} variant="contained" onClick={clearFilters}>
          Clear
        </Button>
      </Grid>
    </ErrorBoundary>
  );
};
